/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cta_UpworkInputs */

const en_cta_upwork = /** @type {(inputs: Cta_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hire on Upwork`)
};

const ar_cta_upwork = /** @type {(inputs: Cta_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وظّفني على Upwork`)
};

const bn_cta_upwork = /** @type {(inputs: Cta_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upwork-এ হায়ার করুন`)
};

const de_cta_upwork = /** @type {(inputs: Cta_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über Upwork beauftragen`)
};

const es_cta_upwork = /** @type {(inputs: Cta_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contratar en Upwork`)
};

const fr_cta_upwork = /** @type {(inputs: Cta_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embaucher sur Upwork`)
};

const pt_cta_upwork = /** @type {(inputs: Cta_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrate no Upwork`)
};

const zh_cta_upwork = /** @type {(inputs: Cta_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Upwork 上招聘`)
};

const tr_cta_upwork = /** @type {(inputs: Cta_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upwork'te İşe Alma`)
};

const ru_cta_upwork = /** @type {(inputs: Cta_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нанимайте на Upwork`)
};

const pl_cta_upwork = /** @type {(inputs: Cta_UpworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatrudnij w Upwork`)
};

/**
* | output |
* | --- |
* | "Hire on Upwork" |
*
* @param {Cta_UpworkInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const cta_upwork = /** @type {((inputs?: Cta_UpworkInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cta_UpworkInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_cta_upwork(inputs)
	if (locale === "bn") return bn_cta_upwork(inputs)
	if (locale === "de") return de_cta_upwork(inputs)
	if (locale === "es") return es_cta_upwork(inputs)
	if (locale === "fr") return fr_cta_upwork(inputs)
	if (locale === "pt") return pt_cta_upwork(inputs)
	if (locale === "zh") return zh_cta_upwork(inputs)
	if (locale === "tr") return tr_cta_upwork(inputs)
	if (locale === "ru") return ru_cta_upwork(inputs)
	if (locale === "pl") return pl_cta_upwork(inputs)
	return en_cta_upwork(inputs)
});